/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbstractLeafOperandExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/AbstractLeafOperandExpressionNodeConverter";
import { ReferenceOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/ReferenceOperandValueImpl";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
import { Assert } from "abweb/utils/Assert";
// import ReferenceOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.ReferenceOperandValue;

export class ReferenceOperandExpressionNodeConverter extends AbstractLeafOperandExpressionNodeConverter {
  convert(expExpressionNode) {
    Assert.assert(expExpressionNode.nodeType === ExpExpressionNodeNodeTypeEnum.REFERENCE);
    const stateWithoutNodeType = this.getStateWithoutNodeType(expExpressionNode);
    if (this.specification?.expTemplateConfiguration != null) {
      return ReferenceOperandValueImpl.fromExpTemplateConfiguration(expExpressionNode.id, stateWithoutNodeType.operandName, this.specification.expTemplateConfiguration, this.specification.expressionDomainModel);
    }
    return new ReferenceOperandValueImpl(stateWithoutNodeType);
  }
}
//# sourceMappingURL=ReferenceOperandExpressionNodeConverter.js.map
